import { makeStyles } from '@material-ui/styles';
import { Modal } from '@material-ui/core';

interface InfoModalProps {
    isOpen: boolean;
}

const InfoModal: React.FC<InfoModalProps> = ({ isOpen, children }) => {
    const classes = useStyles();

    return (
        <Modal open={isOpen}>
            <div className={classes.modal}>{children}</div>
        </Modal>
    );
};

const useStyles = makeStyles(
    theme => ({
        modal: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '90%',
            padding: '40px 24px 20px',
            backgroundColor: theme.palette.greys[100],
            boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.1)',
            borderRadius: 16,
            outline: 'none',
            transform: `translate(-50%, -50%)`,
            [theme.breakpoints.up('sm')]: {
                width: 328,
            },
        },
    }),
    { classNamePrefix: InfoModal.name }
);

export default InfoModal;
